var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 2.085V8.5a2.5 2.5 0 0 0 2.336 2.495L3.5 11h4.414A1.5 1.5 0 0 1 6.5 12H3a3 3 0 0 1-3-3V3.5a1.5 1.5 0 0 1 1-1.415M8.5 0A1.5 1.5 0 0 1 10 1.5v7A1.5 1.5 0 0 1 8.5 10h-5A1.5 1.5 0 0 1 2 8.5v-7A1.5 1.5 0 0 1 3.5 0z"
})));
export default SvgIconCopy;